import { memo } from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { LocalShipping } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useCentralizedExport } from 'contexts/CentralizedExportProvider';
import { InventoryDownloadService, SalesDownloadService } from 'modules/export/services';

const OrderExportDelivery = ({ orderId, path }: { orderId: string; path: string }) => {
  const { t } = useTranslation('order');
  const { triggerExport } = useCentralizedExport();

  const handleExportDelivery = () => {
    triggerExport({
      title: 'common:exportDialog.title',
      confirmation: 'common:exportDialog.confirmation',
      total: 1,
      exportHook: async () => {
        const payload = {
          total: 1,
          search: '',
        };
        return await SalesDownloadService._getExportPath(payload, path || `/orders/export/${orderId}/delivery`);
      },
      downloadFn: InventoryDownloadService._downloadFileToPDF,
      storageKey: '_export_hide_single_order_delivery',
    });
  };

  return (
    <MenuItem onClick={handleExportDelivery}>
      <ListItemIcon>
        <LocalShipping fontSize='small' />
      </ListItemIcon>
      <ListItemText>{t('header.actions.export.exportDelivery')}</ListItemText>
    </MenuItem>
  );
};

export default memo(OrderExportDelivery);
